import { React,useState,useEffect } from "react";
import AOS from "aos";
import Button from "../Button";
import Location_Analysis from "../../images/Industries/Location_Analysis.png"
import Financial_Structuring from "../../images/Industries/Financial_Structuring.png"
import Graded_Inventory from "../../images/Industries/Graded_Inventory.png"
import FormModal from '../../Components/FormModal';

function Tools() {

            // Modal State & Function
            const [modalToggle, setModalToggle] = useState(false);
            function toggle () {
                setModalToggle(!modalToggle);
            }
    const tools = [
        {
            icon: Location_Analysis,
            alt: "Location analysis icon",
            heading: "Location Analysis",
            content: "Our proprietary Property Matrix evaluates locations against your business needs to pinpoint the right site for success."
        },
        {
            icon: Graded_Inventory,
            alt: "Graded Inventory icon",
            heading: "Graded Inventory",
            content: "Using our advanced Inventory Engine, we grade and match properties in your chosen location to find the perfect fit."
        },
        {
            icon: Financial_Structuring,
            alt: "Financial Structuring icon",
            heading: "Financial Structuring",
            content: "Our experts apply proven structuring methods to deliver cost-effective, legally sound acquisition solutions — securing the best terms for your investment."
        },

    ]

    return (

        <>
            <div className="max-w-7xl mx-auto">

                {/* Heading */}
                <div>
                    <h1 className='heading' data-aos="fade-up">Smart tools. Better decisions.</h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
                    <p className="service-description max-w-[800px] mx-auto" data-aos="fade-up" data-aos-duration="1100">Our proprietary systems turn market data into actionable insights, helping you choose the right property, at the right time, on the right terms.</p>

                </div>

                {/* Loopcard */}
                <div className="flex flex-wrap justify-between gap-10 mt-[80px] px-4">
                    {
                        tools.map((items) => {
                            return (
                                <div className="w-[382px] h-fit mx-auto bg-[#F8F6F6] p-[35px] sm:h-[574px]" data-aos="fade-up">
                                    <img className="w-[65px]" src={items.icon} alt={items.alt} />
                                    <h1 className="font-noto text-[26px] font-bold leading-[40px] mt-[20px] lg:text-[32px] lg:mt-[38px]">{items.heading}</h1>
                                    <p className="font-alibaba text-[#5F5D5E] text-[18px] leading-[30px] mt-[25px] mb-[60px] sm:text-[20px]">{items.content}</p>

                                    <Button
                                        name={"Enquire Now"}
                                        design={"filled"}
                                        action={"modal-open"}
                                        modalfunction={toggle}
                                    />

                                </div>
                            )
                        })
                    }
                </div>

            </div>

             <FormModal
                modal={modalToggle}
                active = {toggle}
            />
        </>
    )
}

export default Tools;